//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsIcon} from '@nuskin/ns-icon';
import {NsAnimateHeight} from '@nuskin/design-components';

export default {
  name: 'CollapsibleSection',
  components: {NsIcon, NsAnimateHeight},
  props: {
    /**
     * Whether the accordion section can be collapsed (overrides to keep open)
     */
    notCollapsible: {
      type: Boolean,
      default: false
    },

    /**
     * When not controlling the component with the 'open' prop, this will mount the component in the open state
     */
    startOpen: {
      type: Boolean,
      default: false
    },

    /**
     * Whether the accordion section is open or not
     */
    open: {
      type: Boolean,
      default: undefined
    },

    /**
     * Label for the accordion header (can also be a slot)
     */
    summary: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localOpen:
        this.notCollapsible ||
        (this.open === undefined ? this.startOpen : this.open)
    };
  },
  watch: {
    open(open) {
      if (!this.notCollapsible && open !== undefined) {
        this.localOpen = open;
      }
    }
  },
  methods: {
    handleClick() {
      if (!this.notCollapsible) {
        if (this.open !== undefined) {
          this.$emit('toggle', this.open);
          return;
        }

        this.$emit('toggle', this.localOpen);
        this.localOpen = !this.localOpen;
      }
    }
  }
};
